import service from "@/api/request";
export const getQuestionList = (params) => service.getByParams('/courseAdmin/question/page', params);
export const getQuestionDetail = (id) => service.getByParams('/courseAdmin/question/get', { id });
export const getQuestionsDetail = (ids) => service.getByParams('/courseAdmin/question/batchGet', { ids });
export const changeQuestionStatus = (idList, status) => service.postByJson('/courseAdmin/question/changeStatus', {
    idList,
    status,
});
export const copyQuestion = (idList, categoryId) => service.postByJson('/courseAdmin/question/copy', {
    idList,
    categoryId,
});
export const transferQuestion = (idList, categoryId) => service.postByJson('/courseAdmin/question/move', {
    idList,
    categoryId,
});
export const saveQuestionDetail = (data) => service.postByJson('/courseAdmin/question/addOrUpdate', data);
export const getQuestionCategoryList = (keyword) => service.getByParams('/courseAdmin/question/listCategory', { name: keyword });
export const addQuestionCategory = (data) => service.postByQs('/courseAdmin/question/addCategory', data);
export const updateQuestionCategory = (data) => service.postByJson('/courseAdmin/question/updateCategory', data);
export const deletePaperCategory = (data) => service.postByQs('/courseAdmin/question/delCategory', data);
export const fetchAvailableQuestionNum = (params) => service.getByParams('/courseAdmin/question/questionNumList', params);
export const getRandomQuestionList = (data) => service.postByJson('/courseAdmin/question/randomQuestionList', data);
export const getQuestionListForPaper = (params) => service.getByParams('/courseAdmin/question/validPage', params);
